import React from "react";
import { destination } from "../Constant/Index";

const SolvedSection = () => {
	return (
		<section className="solved-sec pt-5 pb-5 mt-5 mb-4">
			<div className="container">
				<div className="row">
					<div className="col-lg-7 mx-auto">
						<h2 className="main-heading-font dark-color level-2 text-center wow animate__animated animate__zoomIn">
							Solve real problems
						</h2>
						<div className="text-center pb-4">
							<p className="primary-regular-font extra-color-5 level-7">
								In the digital age, your health deserves the smartest care. Lane
								AW Health is the premier online healthcare platform that brings
								comprehensive medical services right to your fingertips.
							</p>
						</div>
					</div>
				</div>
				<div className="solve-detail-img extra-bg-8 radius-20 p-5">
					<div className="row align-items-center">
						<div className="col-lg-6">
							<div className="solved-heading">
								<h5 className="extra-color-5 primary-medium-font level-6">
									"Access a network of certified doctors and specialists for
									consultations, second opinions, and ongoing care all from the
									comfort of your home."
								</h5>
								<h6 className="extra-color-6 primary-regular-font mb-3 mt-2 level-7">
									Thomas Andrew, CEO and founder at MMF
								</h6>
								<a
									href="signin"
									className="btn log-in level-7 primary-regular-font text-decoration-none"
								>
									<span className="bg-wrapper">Read more</span>
								</a>
							</div>
						</div>
						<div className="col-lg-6">
							<figure>
								<img src={destination} className="img-fluid" alt="" />
							</figure>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default SolvedSection;
